import { useMemo } from 'react';
import { PAYMENT_PROVIDERS_NAMES } from 'domain/paySettings/helpers';
import type { PaymentProviderName } from 'domain/paySettings/helpers';

interface ConnectParams {
  providerName: PaymentProviderName;
  [key: string]: unknown;
}

const providerFields: Partial<Record<PaymentProviderName, string[]>> = {
  [PAYMENT_PROVIDERS_NAMES.airwallex]: ['apiKey'],
  [PAYMENT_PROVIDERS_NAMES.checkbook]: ['companyName'],
};

export const useConnectPayload = (params: ConnectParams): Record<string, unknown> => {
  const { providerName, ...rest } = params;

  return useMemo(() => {
    const allowedFields = providerFields[providerName] ?? [];
    const filtered = Object.fromEntries(Object.entries(rest).filter(([key]) => allowedFields.includes(key)));

    return {
      providerName,
      ...filtered,
    };
  }, [providerName, rest]);
};
